import React from 'react';

import styles from './styles.module.scss';
import { prettyKey } from 'helpers/formatters';

const formatValue = (value) => {
  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No';
  }

  if (value === null) {
    return 'Null';
  }

  return value;
};

const DisplayPreActivationInfo = ({ data }) => {
  const renderLevel = (object) => {
    return (
      <ul className={styles.list}>
        {Object.entries(object).map(([key, value]) => (
          <li key={key} className="">
            <span>{prettyKey(key)}:</span>&nbsp;
            {value && typeof value === 'object'
              ? renderLevel(value)
              : formatValue(value)}
          </li>
        ))}
      </ul>
    );
  };

  if (!data) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <b>Results</b>
      {renderLevel(data)}
    </div>
  );
};

export default DisplayPreActivationInfo;
